export default __webpack_public_path__ + "static/media/Claxton.f44b300c.otf";